<!--
 * @Author: DY
 * @Date: 2020-06-16 11:21:56
 * @LastEditTime: 2022-02-09 11:47:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JT_Mobile_test\src\views\salesTerminal\qualityInspection\testDetails.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles testDetails">
            <van-nav-bar
                title="检测详情"
                left-text="质量检测"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section class="main-wrapper">
                <van-cell
                    :value="detailsData.balance_number"
                    title="过磅单编号"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.task_number"
                    title="供应单编号"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.type_name"
                    title="物料名称"
                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.child_type_code"
                    title="子类"
                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.spec_name"
                    title="规格型号"
                    :icon="require('@/assets/images/icons/icon_gy_5.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.station_name"
                    title="接收场站"
                    :icon="require('@/assets/images/icons/icon_gy_2.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.gross_weight + `吨`"
                    title="毛重"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.tare_weight + `吨`"
                    title="皮重"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.deduction_weight + `吨`"
                    title="扣吨"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.deduction_water + `吨`"
                    title="扣水"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.net_weight + `吨`"
                    title="净重"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.net_weight_actual + `吨`"
                    title="实际净重"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.gross_time"
                    title="进站时间"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.tare_time"
                    title="出站时间"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    :value="newValue(detailsData.result)"
                    title="快检结果"
                    :icon="require('@/assets/images/icons/icon_37.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.source_name"
                    title="品牌"
                    :icon="require('@/assets/images/icons/icon_43.png')"
                ></van-cell>
                <van-cell
                    :value="detailsData.remarks"
                    title="备注"
                    :icon="require('@/assets/images/icons/icon_34.png')"
                ></van-cell>
                <div class="img-wrapper">
                    <h2>
                        <i class="iconfont iconxiangji"></i>照片信息
                    </h2>
                    <div class="img-list">
                        <van-uploader
                            v-model="fileList"
                            preview-image
                            preview-full-image
                            multiple
                            :deletable="false"
                            :show-upload="false"
                        ></van-uploader>
                    </div>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            // 详情数据
            detailsData: [],
            fileList: [],
            filesGroupId: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.detailsData = this.$route.params.data;
        this.getFileList();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 获取文件列表
        async getFileList() {
            if (this.detailsData.bqid) {
                // 1.先获取所有文件夹和文件
                try {
                    const url = this.GLOBAL.FILE_BASE_URL_OSS + `api/GetFileList/${this.detailsData.bqid}`;
                    const fileDataArr = await this.$axios.get(url);
                    fileDataArr.forEach(item => {
                        if (item.show_name === '现场照片') {
                            this.filesGroupId = item.id;
                        } else {
                            this.fileList.push({
                                fileId: item.id,
                                url: '',
                            });
                        }
                    });
                    this.$nextTick(() => {
                        this.getFileDetailFun(this.fileList);
                    });
                    // eslint-disable-next-line no-empty
                } catch (e) {}
            }
        },
        // 获取文件下载预览地址
        getFileDetailFun(data) {
            const arr = data;
            arr.forEach(item => {
                this.$axios
                    .get(this.GLOBAL.FILE_BASE_URL_OSS + 'api/GetFileInfo/' + item.fileId)
                    .then(res => {
                        item.url = res.preview_url;
                    })
                    .catch(error => {
                        this.$message.error(error.ErrorCode.Message);
                    });
            });
            this.fileList = arr;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        newValue(data) {
            let display = '';
            if (data === 0) {
                display = '未检测';
            } if (data === 1) {
                display = '合格接收';
            } if (data === 2) {
                display = '让步接收';
            } if (data === 3) {
                display = '退货';
            } if (data === 4) {
                display = '不合格接收';
            }
            return display;
        },
    },
};
</script>
<style lang="stylus">
.testDetails
    height 100%
    section
        height calc(100% - 45rpx)
        overflow-x hidden
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        .van-cell
            font-size 16rpx
            .van-cell__value
                -webkit-box-flex: 2;
                -webkit-flex: 2;
                flex: 2;
    .img-wrapper
        padding 10px 16px;
        h2
            font-size 14rpx;
            color #666666;
            .iconfont
                margin-right 3rpx
        .img-list
            margin-top 10rpx
            width 100%;
            overflow-x auto;
            padding-bottom 5rpx;
            .van-uploader
                width max-content
                >>> .van-image,>>> .van-uploader__upload
                    width 72rpx;
                    height 72rpx
</style>
